import { fondo } from "img";
import { BsGithub, BsGlobe, BsLinkedin } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import styles from "./developers.module.css";

function DevelopersSection() {
  return (
    <section id="desarrolladores" className={styles["developers-section"]}>
      <div className={styles["subcontainer"]}>
        <div className={styles["title"]}>
          <h1 className={styles["developers-h1"]}>Equipo de desarrolladores</h1>
        </div>
        <div className={styles["card-container"]}>
          <div className={styles["card"]}>
            <div id={styles["jeremy"]} className={styles["photo"]}></div>
            <div className={styles["data"]}>
              <p className={styles["text"]}>Jeremy Fonseca</p>

              <a
                className={styles["text"]}
                target="_blank"
                href="https://fontseca.dev"
              >
                <BsGlobe /> fontseca.dev
              </a>

              <a
                className={styles["text"]}
                target="_blank"
                href="mailto:fontseca.dev@outlook.com"
              >
                <MdEmail /> fontseca.dev@outlook.com
              </a>
              <a
                className={styles["text"]}
                target="_blank"
                href="https://www.linkedin.com/in/fontseca"
              >
                <BsLinkedin /> in/fontseca
              </a>

              <a target="_blank" href="https://github.com/fontseca">
                <p className={styles["text"]}>
                  <BsGithub /> @fontseca
                </p>
              </a>
            </div>
          </div>

          <div className={styles["card"]}>
            <div id={styles["johan"]} className={styles["photo"]}></div>
            <div className={styles["data"]}>
              <p className={styles["text"]}>Johan Páiz</p>
              <a
                className={styles["text"]}
                target="_blank"
                href="mailto:johanedfb@gmail.com"
              >
                <MdEmail />
                johanedfb@gmail.com
              </a>
              <a
                className={styles["text"]}
                target="_blank"
                href="https://www.linkedin.com/in/kaimdev"
              >
                <BsLinkedin /> in/kaimdev
              </a>
              <a target="_blank" href="https://github.com/KaimDev">
                <p className={styles["text"]}>
                  <BsGithub /> @KaimDev
                </p>
              </a>
            </div>
          </div>
          <div className={styles["card"]}>
            <div id={styles["kenneth"]} className={styles["photo"]}></div>
            <div className={styles["data"]}>
              <p className={styles["text"]}>Kenneth Lola</p>
              <a
                className={styles["text"]}
                target="_blank"
                href="mailto:kenthsamu@gmail.com"
              >
                <MdEmail />
                kenthsamu@gmail.com
              </a>
              <a
                className={styles["text"]}
                target="_blank"
                href="https://www.linkedin.com/in/kenneth-lola/"
              >
                <BsLinkedin /> in/kenneth-lola/
              </a>
              <a target="_blank" href="https://github.com/kenthLol">
                <p className={styles["text"]}>
                  <BsGithub /> @kenthLol
                </p>
              </a>
            </div>
          </div>
        </div>
        {/* <div className={styles['lineX']}></div>
        <div className={styles['lineY']}></div> */}
      </div>
      <img className={styles["fondo"]} src={fondo} alt="fondo" />
    </section>
  );
}

export default DevelopersSection;
